//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ajaxGetDictItems } from "../../api/api";
export default {
  name: 'NewSelect',
  props: {
    placeholder: {
      type: String,
      default: '',
      required: false
    },
    value: {
      type: String,
      required: false
    },
    codeName: {
      type: String,
      required: false
    }
  },
  data: function data() {
    return {
      selectValue: this.value,
      // url:"/sys/dict/loadTreeData",
      options: []
    };
  },
  created: function created() {
    this.loadData();
  },
  methods: {
    loadData: function loadData() {
      var _this = this;

      var param = {
        codeName: this.codeName
      };
      console.log("传入的表名：" + this.codeName); //根据字典Code, 初始化字典数组

      ajaxGetDictItems(this.codeName, null).then(function (res) {
        if (res.success) {
          //                      console.log(res.result);
          _this.options = res.result;
        } else {
          console.log("查询代码表出错", res);
        }
      }); // getAction(this.url,param).then(res=>{
      //     if(res.success && res.result){
      //         this.options = res.result;
      //     }else{
      //         console.log("查询代码表出错",res)
      //     }
      // })
      // this.options=[{text:"草船借箭2",value:"1"}, {text:"大富翁2",value:"2"},{text:"测试数据2",value:"3"}]
    },
    handleChange: function handleChange(value) {
      this.selectValue = value;
      console.log("selected ".concat(value));
    },
    handleBlur: function handleBlur() {
      console.log('blur');
    },
    handleFocus: function handleFocus() {
      console.log('focus');
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};